import React, { useState } from "react";
import "./career.css";
import ContactUs from "../../components/contactusForm/ContactUs";
import img0 from "../../img/17.svg";
import img1 from "../../img/176.svg";
import img2 from "../../img/1761.svg";
import img3 from "../../img/1762.svg";
import img4 from "../../img/1763.svg";
import img5 from "../../img/1764.svg";
import img6 from "../../img/1765.svg";
import img7 from "../../img/1766.svg";
import img8 from "../../img/1767.svg";
import img9 from "../../img/1768.svg";
import img10 from "../../img/1769.svg";
import img11 from "../../img/17610.svg";
import img12 from "../../img/17611.svg";
import img13 from "../../img/17612.svg";
import img14 from "../../img/17613.svg";
import img15 from "../../img/17614.svg";
import img16 from "../../img/17615.svg";
import img17 from "../../img/17616.svg";
import arrow from "../../img/right-up.png";
import location from "../../img/location.png";
import clock from "../../img/clock.png";
import { Link, useNavigate } from "react-router-dom";


const Career = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  // const naviagte = useNavigate()

  const assignments = [
    {
      text: "Science Assignments",
      image: img0,
      description: "Detailed reports and research support in physics, chemistry, biology, and environmental science."
    },
    {
      text: "Management & Human Resource Assignments",
      image: img1,
      description: "Strategic case studies, HR practices, and organizational behavior analysis for management students."
    },
    {
      text: "Technical Report Assignments",
      image: img2,
      description: "Professional technical documentation and structured reporting on engineering and scientific topics."
    },
    {
      text: "Project Management Assignments",
      image: img3,
      description: "Tailored help with project planning, risk analysis, Gantt charts, and project lifecycle management."
    },
    {
      text: "Law Assignments",
      image: img4,
      description: "Support in case law analysis, legal research, and structured legal writing with proper references."
    },
    {
      text: "Research Proposals/Papers",
      image: img5,
      description: "Help with research formulation, hypothesis creation, literature review, and academic paper writing."
    },
    {
      text: "IT Related Assignments",
      image: img6,
      description: "Expert help with system analysis, databases, cybersecurity, and emerging tech topics."
    },
    {
      text: "Programming Assignments",
      image: img7,
      description: "Clean, commented code and solutions in Python, Java, C++, JavaScript, and more."
    },
    {
      text: "Diploma Works",
      image: img8,
      description: "Complete support for diploma students with practical reports and academic write-ups."
    },
    {
      text: "Nursing Assignments",
      image: img9,
      description: "Detailed assignments on patient care, nursing ethics, case studies, and medical scenarios."
    },
    {
      text: "Construction Based Assignments",
      image: img10,
      description: "Assistance with building design, construction project reports, safety analysis, and CAD support."
    },
    {
      text: "Dissertation Help",
      image: img11,
      description: "End-to-end guidance including proposal, literature review, methodology, and final submission."
    },
    {
      text: "Blogs & Updates",
      image: img12,
      description: "Creative, SEO-optimized blog posts and timely updates for websites and student portals."
    },
    {
      text: "Case Studies",
      image: img13,
      description: "In-depth analysis, real-world application, and structured formats for business and management topics."
    },
    {
      text: "CV Writing",
      image: img14,
      description: "Professional resume and cover letter creation to highlight your skills and achievements."
    },
    {
      text: "Essay & Article Writing",
      image: img15,
      description: "Well-researched, original essays and articles tailored to academic or general purposes."
    },
    {
      text: "Engineering Assignments",
      image: img16,
      description: "Support across mechanical, electrical, civil, and computer engineering with calculations and design."
    },
    {
      text: "Finance & Statistics Assignments",
      image: img17,
      description: "Help with financial modeling, ratio analysis, SPSS, Excel, and statistical interpretation."
    }
  ];


  return (
    <>
      <div className="min-h-screen relative mt-4">
        {/* Main Content */}
        <div className="flex items-center justify-start md:px-16">
          <div className="flex flex-col  mainHeadCareer">
            <h1 className="text-3xl font-bold leading-tight text-start">
              Join Our Team at <br />
              <span className="
              // text-[#0F7AA6]
               ahHub">The Assignment Hub</span>
            </h1>
            <p className="text-base font-normal leading-5">
              Empowering students worldwide with top-notch academic assistance.
            </p>
          </div>
          {/* <div className="hidden md:block md:w-1/2">
            <img
              src="/assets/Rectangle 4819.svg" // Replace with your image URL
              alt="career"
              className="shadow-md w-full"
            />
          </div> */}
        </div>

        {/* Hiring Message */}
        {/* <div className="bg-[#F6F6F6] mt-12 py-4 text-center font-serif text-gray-500">
          <h1 className="text-4xl font-normal leading-tight">
            We are not hiring right now!
          </h1>
        </div> */}

        <div className="container  px-2 md:px-16 py-4 mainHeadCareer">
           {/* Job Listings */}
        <div className="w-full space-y-4 my-4">
          <Link
            className="w-full p-4 md:p-8 border-2 border-gray-500 hover:border-black hover:bg-slate-200 rounded-md flex flex-col md:flex-row justify-between items-start cursor-pointer transition-all"
            // onClick={() => { naviagte("/career/ACW") }}
            to="/career/acw"
          >
            <div className="w-full md:w-3/4 mb-4 md:mb-4">
              <h1 className="text-lg md:text-xl font-medium mb-2">Academic Content Writer</h1>
              <p className="mb-3">Join our team as an Academic Content Writer / Research Analyst</p>
              <div className="flex flex-wrap gap-2">
                <div className="flex p-2 items-center border border-black rounded-3xl gap-2">
                  <img src={location} alt="" className="h-5 w-5" />
                  <span>100% remote</span>
                </div>
                <div className="flex p-2 items-center border border-black rounded-3xl gap-2">
                  <img src={clock} alt="" className="h-5 w-5" />
                  <span>Full-time</span>
                </div>
              </div>
            </div>
            <button className="flex items-center font-semibold border-2 border-transparent p-2 rounded-md hover:border-[#38419a] hover:text-[#38419a] self-end md:self-auto">
              Apply
              <img src={arrow} className="h-5 w-5 ml-1" alt="" />
            </button>
          </Link>

          <Link
            className="w-full p-4 md:p-8 border-2 border-gray-500 hover:border-black hover:bg-slate-200 rounded-md flex flex-col md:flex-row justify-between items-start cursor-pointer transition-all"
            // onClick={() => { naviagte("/career/ME") }}
            to="/career/ME"
          >
            <div className="w-full md:w-3/4 mb-4 md:mb-4">
              <h1 className="text-lg md:text-xl font-medium mb-2">Marketing Executive</h1>
              <p className="mb-3">Join our team as a Marketing Executive</p>
              <div className="flex flex-wrap gap-2">
                <div className="flex p-2 items-center border border-black rounded-3xl gap-2">
                  <img src={location} alt="" className="h-5 w-5" />
                  <span>Kota, Rajasthan</span>
                </div>
                <div className="flex p-2 items-center border border-black rounded-3xl gap-2">
                  <img src={clock} alt="" className="h-5 w-5" />
                  <span>Full-time</span>
                </div>
              </div>
            </div>
            <button className="flex items-center font-semibold border-2 border-transparent p-2 rounded-md hover:border-[#38419a] hover:text-[#38419a] self-end md:self-auto">
              Apply
              <img src={arrow} className="h-5 w-5 ml-1" alt="" />
            </button>
          </Link>
        </div>

        </div>

          {/* Job Listings */}
        

        {/* What We Offer */}
        <div className="container mx-auto">
          <div className="w-full mx-auto py-2">
            <h1 className="text-3xl lg:text-4xl font-semibold mainHeadCareer md:px-16">What we offer</h1>
            <div className="w-full mx-auto py-4">

              {/* <h2 className="text-xl font-semibold mb-4 px-16">What we offer</h2> */}
              {assignments.map((item, index) => (
                <div
                  key={index}
                  className=" justify-between flex p-2 flex-wrap items-center border-b text-3xl  transition-all duration-500 hover:bg-[#E5F3FD] cursor-pointer pl-2"
                  style={{ borderColor: "#B7B7B7" }}
                  onMouseEnter={() => setHoveredItem(item.image)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <div>

                    <h3 className="text-3xl font-serif mb-2">{item.text}</h3>
                    <p className="text-sm text-[#000]">{item.description}</p>
                  </div>

                  <img alt={item.text}
                    src={item.image}
                    className={`border-amber-700 hidden lg:block transform w-64 h-44 mr-5 transition-opacity duration-700 rounded-lg ${hoveredItem === item.image ? "opacity-100" : "opacity-0"
                      }`}
                  />

                  <img alt={item.text}
                    src={item.image}
                    className={`border-amber-700 lg:hidden transform w-64 h-44 mr-5 transition-opacity duration-700 rounded-lg `}
                  />


                </div>


              ))}


            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Career;
